export default __webpack_public_path__ + "assets/d515439f59f91fd2c9cf979dd6e187ac.jpg";